<template>
<span>
    <pic v-if="image" :src="image"/>

    <input ref="input"
           v-model="input"
           type="text"
           class="odr-swipecard__input"
           @blur="focusInput">

    <div v-if="validation_showError && validation_error"
         class="odr-error-message"
         :class="{
             'odr-error-message_plain': $root.appConfig.mode !== 'chat'
         }">{{ validation_error }}</div>
</span>
</template>

<script>
import '@/scss/blocks/swipecard.scss';

import validationMixin from '@/utils/mixins/validation';
import focusMixin from '@/utils/mixins/focus';

let timeout = null;

export default {
    mixins: [validationMixin, focusMixin],
    props: {
        dataQa: {},
        id: {},
        value: {},
        values: {},
        image: {},
        inputDelay: {},
    },
    data () {
        return {
            input: this.value,
        };
    },
    watch: {
        input () {
            if (this.input && this.input.length > 100) {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    this.$emit('input', this.input);
                    this.$emit('finished', this.id);
                }, this.inputDelay || this.$root.appConfig.swipeCardInputDelay);
            }
        },
    },
    mounted () {
        this.focusInput();
        window.addEventListener('blur', this.focusInput);
        window.addEventListener('focus', this.focusInput);
    },
    destroyed () {
        window.removeEventListener('blur', this.focusInput);
        window.removeEventListener('focus', this.focusInput);
    },
    methods: {
        focusInput () {
            if (this.$refs.input) {
                this.$refs.input.focus({ preventScroll: true });
            }
        },
        focusin () {
            this.focusInput();
        },
        validation_isEmpty () {
            return !this.input;
        },
    },
    components: {
        pic: require('@clearwave/odoro-markup/lib/vue/pic.vue').default,
    },
};
</script>
